module.exports = __webpack_public_path__ + "img/bridge-03.bed427f3.png";